





















import Vue from 'vue';

export default Vue.extend({
	name: 'AboutMe',
	created(){
		require('firebase/app').database().ref('AboutMeItem')
			.once('value', (snapshot: any) => {this.list = snapshot.val()});
	},

	data() {
		return {
			list : [],
		};
	},		
})
